import { PageType } from '@/constants'
import { useStore } from '@/containers'

interface SalePriceType {
  type?: string
  classes?: string
  finalPrice: number
}

export const SalePrice = ({ finalPrice, classes, type }: SalePriceType) => {
  const { selectedLang } = useStore()
  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'USD'
      default:
        return 'VND'
    }
  }

  return (
    <span
      className={`text-xl font-extrabold mb-1 leading-none ${
        classes ? classes : ''
      } ${type == PageType.PRODUCT ? 'text-dark-900' : 'text-dark-900'}  `}
    >
      {finalPrice &&
        finalPrice
          .toLocaleString(selectedLang as string, {
            style: 'currency',
            currency: currency(selectedLang as string),
          })
          .replace(/\s₫/g, '')}
      {type == PageType.PRODUCT ? (
        <span className={`font-bold text-2xl ml-[2px] leading-none`}>đ</span>
      ) : (
        <sup className={`text-sm font-bold`}>đ</sup>
      )}
    </span>
  )
}

export default SalePrice
